
import {Vue, Component, Prop} from 'vue-property-decorator';
import TeacherIcon from 'src/modules/teacher/TeacherIcon.vue';

@Component({
  components: {TeacherIcon},
  })
export default class TeacherChatMessage extends Vue {
  @Prop({default: false}) fromUser!: boolean;
  @Prop({default: undefined}) size: number;
  @Prop({default: false}) loading!: boolean;
}
